const List3GroupTypes = {
  HEADERS: 'headers',
  LINK: 'link',
};

module.exports = List3GroupTypes;
